import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  public loading$ = signal(false);

  constructor () { }

  set loading(state: boolean) {
    this.loading$.set(state);
  }
}
